import { render, staticRenderFns } from "./TeamSelection.vue?vue&type=template&id=19ac2a8c&scoped=true&"
import script from "./TeamSelection.vue?vue&type=script&lang=js&"
export * from "./TeamSelection.vue?vue&type=script&lang=js&"
import style0 from "./TeamSelection.vue?vue&type=style&index=0&id=19ac2a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ac2a8c",
  null
  
)

export default component.exports